import { Component } from "react";
import { Qualifiers } from "common/components/queryBuilder/qualifiers";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export class SavedFilters extends Component {
    static outputCategories(grouped) {
        return Object.keys(grouped).map((key) => (
            <span key={`filter_details_${key}`}>
                <span>{grouped[key][0].pivot_alias}: </span>
                <span>{grouped[key].map((g) => g.alias).join(",")}; </span>
            </span>
        ));
    }
    
    getByOperator(filter, operator) {
        const filterQualifiers = new Qualifiers({ value: filter.qualifiers });
        const categories = Array.from(new Set(filterQualifiers.value.map((c) => c.category)));
        const grouped = {};
        categories.forEach((category) => {
            const tokens = filterQualifiers.toTokens().filter((t) => t.category === category && t.operator === operator);
            const srcPivotData = this.props.allData[category] || [];
            const merged = tokens.map((token) => {
                const srcToken = srcPivotData.find((s) => (s.ref === token.ref) || (Qualifiers.normalizeValue(s.ref) === `"${token.ref}"`));
                return { ...token, ...srcToken };
            });
            if (merged.length) {
                grouped[category] = merged;
            }
        });
        if (Object.keys(grouped).length) {
            return (<div className="q-content" key={`category_${grouped}`}>{SavedFilters.outputCategories(grouped)}</div>);
        }
        return (<span>None</span>);
    }
    
    filterClick = (id) => () => {
        this.props.savedFilterClick(id);
    };
    
    deleteFilter = (id) => (e) => {
        e.stopPropagation();
        this.props.deleteFilter(id);
    };
    
    renderFilter(filter) {
        return (
            <div key={`filter_${filter._id}`} onClick={this.filterClick(filter._id)} className="filter">
                <h5>{filter.name}</h5>
                <div className="include-qualifiers"><div className="filter-label">Include:</div><div className="q-content"> {this.getByOperator(filter, "=")}</div></div>
                <div className="exclude-qualifiers"><div className="filter-label">Exclude:</div><div className="q-content"> {this.getByOperator(filter, "!=")}</div></div>
                <div className="delete-filter" onClick={this.deleteFilter(filter._id)}>
                    <FontAwesomeIcon className="delete-filter-icon" aria-hidden icon={faTimes} />
                </div>
            </div>
        );
    }
    
    render() {
        return (
            <div className="saved-fitlers-box">
                <header className="saved-filters-header">Saved filters</header>
                <div className="saved-filters">{this.props.filters.map((f) => this.renderFilter(f))}</div>
            </div>
        );
    }
}
